import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import App from "./App";
import { PTagFormProvider } from "./contexts/PTagFormContext";
import './i18n'; 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <PTagFormProvider>
      <App />
    </PTagFormProvider>
  // </React.StrictMode>
);

// The real app has now painted over the static loading gif, so drop it.
const initialSplash = document.getElementById("initial-splash");
if (initialSplash) {
  initialSplash.remove();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
